import React from 'react';
import { Alert } from 'react-bootstrap';
import { shortHash } from '../../features/riggingJobStatus';

export default function RiggingExecutionPackageSummary({ preview, packageRecord }) {
  if (packageRecord) {
    return (
      <div data-testid="rigging-execution-package">
        <dl className="row mb-0">
          <dt className="col-sm-4">Schema</dt>
          <dd className="col-sm-8 mono">{packageRecord.schema_version}</dd>
          <dt className="col-sm-4">Package SHA-256</dt>
          <dd className="col-sm-8 mono">{packageRecord.package_sha256}</dd>
          <dt className="col-sm-4">Short hash</dt>
          <dd className="col-sm-8 mono">{shortHash(packageRecord.package_sha256)}</dd>
        </dl>
        <p className="small text-muted mt-2 mb-0">
          These inputs are immutable for this job. Future Rigging Bible changes will not affect it.
        </p>
      </div>
    );
  }

  if (!preview) {
    return (
      <p className="text-muted mb-0">
        Execution package preview will appear after required inputs are selected.
      </p>
    );
  }

  return (
    <div data-testid="rigging-execution-package-preview">
      <Alert variant="info" className="py-2">
        <strong>Execution Package Preview</strong>
        <div>
          The server will generate and hash the immutable execution package when the job is
          created.
        </div>
      </Alert>
      <dl className="row mb-0">
        <dt className="col-sm-4">Schema</dt>
        <dd className="col-sm-8 mono">{preview.schema}</dd>
        <dt className="col-sm-4">Operation</dt>
        <dd className="col-sm-8">{preview.job?.operation}</dd>
        <dt className="col-sm-4">Scene</dt>
        <dd className="col-sm-8 mono">{preview.source?.scene_path}</dd>
        <dt className="col-sm-4">Maya</dt>
        <dd className="col-sm-8 mono">{preview.runtime?.maya_version}</dd>
        <dt className="col-sm-4">FabricatorStudio</dt>
        <dd className="col-sm-8 mono">{preview.runtime?.fabricatorstudio_version}</dd>
        <dt className="col-sm-4">Artifact contract</dt>
        <dd className="col-sm-8 mono">
          {(preview.artifact_contract?.required_types || []).join(', ') || '—'}
        </dd>
      </dl>
    </div>
  );
}
